<!-- @format -->
<template>
    <div class="na-ad-box-dock has-text-centered">
        <router-link class="is-hidden-mobile" :to="{ name: 'kwsubscribe' }"
            ><img
                class="na-link na-ad-image"
                :src="imageUrl('HouseAd-SubscribeToKW.png')"
                alt="Subscribe to the Kingston Wire"
                title="Subscribe to the Kingston Wire"
                width="250"
                height="250"
                loading="lazy"
        /></router-link>
        <router-link class="is-hidden-tablet" :to="{ name: 'kwsubscribe' }"
            ><img
                class="na-link na-ad-image"
                :src="imageUrl('HouseAd-SubscribeToKW.png')"
                alt="Subscribe to the Kingston Wire"
                title="Subscribe to the Kingston Wire"
                width="250"
                height="250"
                loading="lazy"
        /></router-link>
    </div>
</template>

<script>
import { mediaMixin } from '@/mixins/MediaMixin.js';

export default {
    mixins: [mediaMixin]
};
</script>
